import { FC } from 'react'
import { PageContextProps } from 'interfaces/pageContext'
import { usePageContext } from 'helpers/pageHelpers'
import { PageContext } from 'components/features/pfm/PageContext/PageContext'

export const MergePageContext: FC<Partial<PageContextProps>> = (props) => {
  const { children, ...restProps } = props
  const context = {
    ...usePageContext(),
    ...restProps,
  }

  return (
    <PageContext.Provider value={ context }>
      { children }
    </PageContext.Provider>
  )
}
